export const TRANSACTION_NOTICE_KEY = 'transaction_sync_state_key'
